<template>
    <rkm-overlay>
        <rkm-layout-body title="Cadastro de jornada">
            <template v-slot:actions>
                <rkm-button
                    @click="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="handleCreate"
                    authorize="create-ambulatorio-jornada"
                    color="primary"
                >
                    Cadastrar jornada
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    :id="id"
                    ref="Form"
                />
            </rkm-layout-content>

            <Modal
                :usuario-id="id"
                ref="ModalCadastro"
            />
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/ambulatorio/jornada/Form'
import Modal from '@/components/ambulatorio/jornada/components/cadastro/Modal'

export default {
    components: {
        Form,
        Modal,
    },
    methods: {
        handleCreate() {
            this.create()
        },
        create() {
            this.$refs.ModalCadastro.create()
        },
        handleExit() {
            this.$router.push('/ambulatorio/jornada/index')
        },
    },
    props: {
        id: { type: Number, default: null },
    },
}
</script>